import { render, staticRenderFns } from "./IconCards.vue?vue&type=template&id=3a9dda16&"
import script from "./IconCards.vue?vue&type=script&lang=js&"
export * from "./IconCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports